import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class CancellationReportService {
  constructor(private http: HttpUtilService) {}

  CancellationReport(
    FromDate: string,
    ToDate: string,
  ): Observable<any> {
    return this.http.post(
      "SalesReportService.asmx/CancellationReport",
      {
        model: {
          FromDate,
          ToDate,
        },
      },
    );
  }
}
